import React from "react";
import Loader from "../../components/Loader/Loader";
import dataCorporate from "../../data/Slider/corporate-business-data.json"
import HeroSlider from "../../components/Hero/HeroSlider";
import AboutUs from "../../components/WhoWeAre/AboutUs";
import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import Team from "../../components/Team/Team";
import ClientsBrand from "../../components/ClientsBrand/ClientsBrand";
import HeadingSection from "../../components/HeadingSection/HeadingSection";
import Features from "../../components/WhoWeAre/Features";

const CorporateBusiness = () => (
  <Loader>
    <div
      title="Section 5"
      subtitle="some"
      id="section5"
    ></div>
    <Header />
    <HeroSlider data={dataCorporate} />
    <AboutUs 
      title="Section 1"
      subtitle="some"
      id="section1"
    />
    <Features
      title="Section 2"
      subtitle="some"
      id="section2"
    />
    <Team 
      title="Section 3"
      subtitle="some"
      id="section3"
    />
    <ClientsBrand classAppend="mt-50"
      title="Section 4"
      subtitle="some"
      id="section4"
    >
      <HeadingSection title="Наші партнери"/>
    </ClientsBrand>
    <Footer />
  </ Loader>
);

export default CorporateBusiness;
